module.exports = __webpack_public_path__ + "img/home-v2-2.9d5731ea.jpg";